define('view/module/menu/MenuListView',['require','marionette','view/module/menu/MenuListItemView'],function (require) {

    var Marionette = require('marionette');
    var MenuListItemView = require('view/module/menu/MenuListItemView');

    /**
     * Reviews composite module view (reviews container)
     *
     * @class MenuListView
     */
    return Marionette.CompositeView.extend({

        template: '#menu_list_view',
        childView: MenuListItemView,
        childViewContainer: '#sb_menu_list_items_container',
/*        childViewOptions: function(model, index) {
            return {
                logged_in: this._reviewModel.get('logged_in'),
                childIndex: index
            }
        },*/
        collectionEvents: {
            sync: 'render'
        },


        serializeData: function () {
            var result = Marionette.CompositeView.prototype.serializeData.apply(this);

            return result;
        },

        getTemplate: function () {
            if (this.getOption('is_footer')) {
                return '#menu_list_footer_view';
            }
            return this.template;
        }
    });

});
